import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  FiCheck,
  FiShield,
  FiZap,
  FiClock,
  FiArrowRight,
  FiLock,
  FiPhoneCall,
  FiAward,
} from "react-icons/fi";
import Header from "../../../components/layouts/Header";
import Footer from "../../../components/layouts/Footer";
import {
  setcurrentorderDetails,
  setselectBossPlan,
} from "../../../redux/athentication/Athentication";
import "./BossPlansNew.css";

const BossPlans = ({ isEmbedded = false }) => {
  const { loginData } = useSelector((store) => store.Athentication);
  const [activeTab, setActiveTab] = useState("50");
  const [selectedPlanId, setSelectedPlanId] = useState("02"); // default 6 Months (Save 50%)

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const plans50 = [
    {
      id: "01",
      mounts: "3 Months",
      mountsselect: 3,
      counts: "100",
      price: "2000",
      totalPrice: "3000",
      offerPersentage: "33.33",
      package: "Basic Package",
      badge: "",
    },
    {
      id: "02",
      mounts: "6 Months",
      mountsselect: 6,
      counts: "200",
      price: "3000",
      totalPrice: "6000",
      offerPersentage: "50",
      package: "Silver Package",
      badge: "MOST POPULAR",
    },
    {
      id: "03",
      mounts: "9 Months",
      mountsselect: 9,
      counts: "300",
      price: "5000",
      totalPrice: "9000",
      offerPersentage: "44.44",
      package: "Gold Package",
      badge: "",
    },
    {
      id: "04",
      mounts: "12 Months / 1 Year",
      mountsselect: 12,
      counts: "500",
      price: "9000",
      totalPrice: "18000",
      offerPersentage: "50",
      package: "Platinum Package",
      badge: "BEST VALUE",
    },
  ];

  const plans25 = [
    {
      id: "25-01",
      mounts: "3 Months",
      mountsselect: 3,
      counts: "50",
      price: "1200",
      totalPrice: "1800",
      offerPersentage: "33.33",
      package: "Starter Package",
      badge: "",
    },
    {
      id: "25-02",
      mounts: "6 Months",
      mountsselect: 6,
      counts: "100",
      price: "2000",
      totalPrice: "3600",
      offerPersentage: "45",
      package: "Growth Package",
      badge: "MOST POPULAR",
    },
    {
      id: "25-03",
      mounts: "9 Months",
      mountsselect: 9,
      counts: "150",
      price: "3200",
      totalPrice: "5400",
      offerPersentage: "40",
      package: "Pro Package",
      badge: "",
    },
    {
      id: "25-04",
      mounts: "12 Months / 1 Year",
      mountsselect: 12,
      counts: "250",
      price: "5500",
      totalPrice: "10000",
      offerPersentage: "45",
      package: "Elite Package",
      badge: "BEST VALUE",
    },
  ];

  const currentList = activeTab === "50" ? plans50 : plans25;
  const selectedPlan = currentList.find((p) => p.id === selectedPlanId) || currentList[1];

  const generateOrderId = () => {
    const currentTimestamp = new Date().getTime();
    const randomThreeDigitNumber = Math.floor(100 + Math.random() * 900);
    return `${currentTimestamp}${randomThreeDigitNumber}`.slice(0, 12);
  };

  const handleCheckout = (e) => {
    if (e) e.preventDefault();
    if (!selectedPlan) return;

    const orderId = generateOrderId();
    const formData = {
      order_id: orderId,
      amount: String(selectedPlan.price),
      customer_id: loginData?._id || "64f8a123bc45678901234567",
      customer_email: loginData?.email || "customer@ewrealty.com",
      customer_phone: loginData?.mobile || "9063483711",
      payment_page_client_id: "hdfcmaster",
      action: "paymentPage",
      return_url: `${window.location.origin}/payment-process`,
      description: `Purchase of ${selectedPlan.package} (${selectedPlan.mounts}) on EwRealty`,
      first_name: loginData?.name || "Customer",
      last_name: "",
    };

    dispatch(setcurrentorderDetails(formData));
    dispatch(setselectBossPlan(selectedPlan));
    navigate("/payment-process");
  };

  return (
    <div className={`mgh-boss-page ${isEmbedded ? "embedded" : ""}`}>
      {!isEmbedded && <Header />}

      <main className="mgh-boss-container">
        {/* ================= Hero Section ================= */}
        <section className="mgh-boss-hero">
          <div className="mgh-boss-badge">
            <FiAward />
            <span>Broker & Owner Supply Solutions (BOSS)</span>
          </div>

          <h1 className="mgh-boss-title">
            <span className="mgh-boss-title-part1">Package Supply Solutions &</span>{" "}
            <span className="mgh-boss-title-part2">Dealer Plans</span>
          </h1>

          <p className="mgh-boss-subtitle">
            Unlock high-intent buyer leads, boosted listings, and verified phone numbers
            to sell or rent properties faster.
          </p>

          {/* Tier Switcher */}
          <div className="mgh-boss-tab-switch">
            <button
              type="button"
              className={`mgh-boss-tab-btn ${activeTab === "50" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("50");
                setSelectedPlanId("02");
              }}
            >
              50 Contacts / Month
            </button>
            <button
              type="button"
              className={`mgh-boss-tab-btn ${activeTab === "25" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("25");
                setSelectedPlanId("25-02");
              }}
            >
              25 Contacts / Month
            </button>
          </div>
        </section>

        {/* ================= Pricing Cards Grid ================= */}
        <div className="mgh-boss-grid">
          {currentList.map((plan) => {
            const isSelected = selectedPlanId === plan.id;
            return (
              <div
                key={plan.id}
                className={`mgh-boss-card ${isSelected ? "selected" : ""}`}
                onClick={() => setSelectedPlanId(plan.id)}
              >
                {plan.badge && <span className="mgh-boss-ribbon">{plan.badge}</span>}

                <div className="mgh-boss-card-top">
                  <div className="mgh-boss-duration-row">
                    <span className="mgh-boss-duration">{plan.mounts}</span>
                    <span className="mgh-boss-discount-chip">
                      SAVE {Math.round(Number(plan.offerPersentage))}%
                    </span>
                  </div>

                  <p className="mgh-boss-package-name">{plan.package}</p>

                  <div className="mgh-boss-price-block">
                    <span className="mgh-boss-current-price">₹{plan.price}</span>
                    <span className="mgh-boss-original-price">₹{plan.totalPrice}</span>
                  </div>

                  <ul className="mgh-boss-features-list">
                    <li className="mgh-boss-feature-item">
                      <FiCheck className="mgh-boss-check-icon" />
                      <span>Access <strong>{plan.counts} posts</strong></span>
                    </li>
                    <li className="mgh-boss-feature-item">
                      <FiCheck className="mgh-boss-check-icon" />
                      <span><strong>Verified buyer</strong> inquiries</span>
                    </li>
                    <li className="mgh-boss-feature-item">
                      <FiCheck className="mgh-boss-check-icon" />
                      <span>Instant SMS & WhatsApp alerts</span>
                    </li>
                    <li className="mgh-boss-feature-item">
                      <FiCheck className="mgh-boss-check-icon" />
                      <span>Priority search ranking</span>
                    </li>
                  </ul>
                </div>

                <div className="mgh-boss-select-indicator">
                  <FiCheck size={16} />
                  <span>{isSelected ? "Plan Selected" : "Select Plan"}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* ================= Checkout Card ================= */}
        <div className="mgh-boss-checkout-card">
          <div className="mgh-checkout-summary">
            <h4>
              Selected: {selectedPlan?.package} ({selectedPlan?.mounts})
            </h4>
            <p>
              Includes {selectedPlan?.counts} posts with full buyer contact access • Instant activation
            </p>
          </div>

          <button
            type="button"
            className="mgh-checkout-btn"
            onClick={handleCheckout}
          >
            <span>Proceed to Buy — ₹{selectedPlan?.price}</span>
            <FiArrowRight size={18} />
          </button>
        </div>

        {/* ================= Trust & Security Badges ================= */}
        <div className="mgh-boss-trust-row">
          <div className="mgh-trust-item">
            <FiLock style={{ color: "#10b981" }} />
            <span>100% Secure Checkout via HDFC Gateway</span>
          </div>
          <div className="mgh-trust-item">
            <FiZap style={{ color: "#ea580c" }} />
            <span>Instant Plan & Credits Activation</span>
          </div>
          <div className="mgh-trust-item">
            <FiPhoneCall style={{ color: "#2563eb" }} />
            <span>Seller Support: +91 90634 83711</span>
          </div>
        </div>
      </main>

      {!isEmbedded && <Footer />}
    </div>
  );
};

export default BossPlans;
